<template>
  <div style="background: white; z-index: 10" v-show="isActive"
    :class="{ widgetContainer: !isFixed, legendContainer: !isFixed }" :id="isFixed ? 'legendIDFix' : 'legendID'">
    <div v-if="!isFixed" class="map-tool-window-header" 

    id="legendIDheader">
      <p class="map-tool-window-header-title">Simbología</p>
      <div class="map-tool-window-header-actions">
          <button class="control-btn" @click="exitLegend()">
          <!-- <font-awesome-icon icon="times"></font-awesome-icon> -->
            <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
        </button>
      </div>
      
    </div>

    <div :class="{ widgetBody: !isFixed }" v-show="!isHidden">

      <div :class="{ resizable: !isFixed }" v-if="activeLayers.length > 0">

        <div v-for="(layers, category) in groupedLayers" :key="category" class="legend-category">

          <div class="legend-category-title">
            {{ category }}
          </div>

          <div class="legend-category-content">
            <ListPlegableLegend v-for="(layer, i) in layers" :key="layer.id || i" :layer="layer" />
          </div>

        </div>
      </div>

      <div :class="{ resizable: !isFixed }" v-else>
        <span>No hay datos</span>
      </div>
    </div>
  </div>
</template>

<script>
import ListPlegableLegend from "@/components/mapControls/legends/ListPlegableLegend.vue";
import { draggableDiv } from "@/components/mixin/draggableDiv.js";
import { vuex } from "@/components/mixin/vuex.js";

export default {
  name: "LegendPanel",
  props: ["isActive", "isFixed"],
  mixins: [draggableDiv, vuex],

  data() {
    return { isHidden: false };
  },

  components: { ListPlegableLegend },

  computed: {
    groupedLayers() {
      const groups = {};
      for (const layer of this.activeLayers) {
        const cat = layer.category_name || "Sin categoría";
        if (!groups[cat]) groups[cat] = [];
        groups[cat].push(layer);
      }
      return groups;
    },
  },

  methods: {
    exitLegend() {
      this.$emit("onLegendAction", "legend", "exit", null);
    },
  },

  mounted() {
    this.makeDraggable("legendID");
  },
};
</script>

<style scoped lang="scss">
.legendContainer {
  left: 78vw;
  top: 4em;
  /* Card aesthetics */
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

// .widgetHeader {
//   background: #006FB3;
//   color: white;
//   padding: 10px 15px;
//   border-top-left-radius: 8px;
//   border-top-right-radius: 8px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }

.widgetBody {
  padding: 0;
  background: #f8fafc;
  max-height: 60vh;
  overflow-y: auto;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.resizable {
  margin-top: 0;
  height: auto;
  max-height: 60vh;
  min-height: 10vh;
  min-width: 15vw;
  resize: vertical;
  overflow: auto;
  padding: 10px;
}

.legend-category {
  margin-bottom: 1em;
  padding: 0;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.legend-category-title {
  background: #006FB3;
  color: white;
  padding: 8px 12px;
  font-weight: bold;
  font-size: 0.9em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.legend-category-content {
  background: #ffffff;
  padding: 8px;
}

.widget-container-alt {
  position: relative;
}
</style>